// @flow

import React, { useState } from "react";
import "./styles.css";
import uuid from "uuid";
import classNames from "classnames";
import Address from "../../models/address";
import TextBox from "../text-box";
import FAB from "../fab";
import * as R from "ramda";

const type = "text";
const excludedProps = ["children", "className", "errorMessage", "isError", "labelText"];

type PropsType = {
    id?: string,
    className?: string,
    disabled?: boolean,
    errorMessage?: string,
    isError?: boolean,
    onChange: any => any,
    labelText?: string,
    readOnly?: boolean,
    required?: boolean,
    style?: Object,
    value: Address
};

const filterProps = (_props: any): any => ({
    ...Object.keys(_props)
        .filter(key => excludedProps.indexOf(key) === -1)
        .reduce((obj, key) => ({ ...obj, [key]: _props[key] }), {}),
    type,
    id: _props.id || uuid()
});


export const AddressControl = (props: PropsType) => {
    const {
        value = {},
        className,
        labelText = "Address",
        disabled = false,
        isError = false,
        required = false,
        errorMessage = "Error",
        onChange,
        readOnly = false
    } = props;
    const componentClass = classNames("address-control--label", {
        "is-required": required,
        "is-error": isError,
        "is-disabled": disabled,
        "is-read-only": readOnly,
        [className]: Boolean(className)
    });
    const [isOpen, setIsOpen] = useState(false);
    const inputProps = filterProps(props);
    const changeAddress = R.curry((key, val) => {
        const newAddress = { ...value, [key]: val };
        onChange(newAddress);
    });
    return (
        <div className={ classNames("address-control", { "is-open": isOpen }) }>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */ }
            <label
                className={ componentClass }
                htmlFor={ inputProps.id }
                onClick={ () => setIsOpen(!isOpen) }
            >
                <span className="address-control--label-text">{ labelText }</span>
                <span className={ "address-control--error-message" }>{ errorMessage }</span>
                <input
                    readOnly={ true }
                    { ...inputProps }
                    value={ Address.toString(value) }
                />
            </label>
            <div className={ "address-control--slider" }>
                <div className={ "address-control--slider-content" }>
                    <FAB
                        className={ "address-control--close-button" }
                        icon={ "faAngleUp" }
                        onClick={ () => {
                            setIsOpen(false);
                        } }/>
                    <div className="address-control--form address-control--grid-container">
                        <div className="address-control--street">
                            <TextBox
                                labelText={ "Street" }
                                onChange={ changeAddress("street") }
                                value={ value.street }/>
                        </div>
                        <div className="address-control--street2">
                            <TextBox
                                labelText={ "Street 2" }
                                onChange={ changeAddress("street2") }
                                value={ value.street2 }/>
                        </div>
                        <div className="address-control--city">
                            <TextBox
                                labelText={ "City" }
                                value={ value.city }
                                onChange={ changeAddress("city") }
                            />
                        </div>
                        <div className="address-control--state">
                            <TextBox
                                labelText={ "State" }
                                value={ value.state }
                                onChange={ changeAddress("state") }
                            />
                        </div>
                        <div className="address-control--zip">
                            <TextBox
                                labelText={ "ZIP" }
                                value={ value.zip }
                                onChange={ changeAddress("zip") }
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
